import React, { useState, useEffect, useRef, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useNavigate, Navigate, useParams } from "react-router-dom";
import { lazyWithRetry as lazy } from "../utils/lazyWithRetry";

/** כינוי שגוי ב-URL (קו תחתון) — מפנה לנתיב הקנוני כדי שלא ייטען NotFound מאחורי overlay החיפוש */
function VacationPackagesLegacyPathRedirect() {
  const { pathname, search, hash } = useLocation();
  const to = `${pathname.replace(/^\/vacation_packages/, "/vacation-packages")}${search}${hash}`;
  return <Navigate to={to} replace />;
}

/** /flights/search הוסר — הפניה לקטלוג חבילות (טיסות) עם אותם query params */
function FlightsSearchPublicLegacyRedirect() {
  const { search } = useLocation();
  const sp = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  sp.set("category", "flights");
  const q = sp.toString();
  return <Navigate to={q ? `/vacation-packages?${q}` : "/vacation-packages?category=flights"} replace />;
}

function LegacySupplierHotelRedirect() {
  const { hotelId } = useParams();
  const { search, hash } = useLocation();
  return (
    <Navigate to={`/p/dashboard/hotel/${encodeURIComponent(hotelId || "")}${search}${hash}`} replace />
  );
}

function HebrewDashboardCanonicalRedirect() {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/he\/dashboard/, "");
  return <Navigate to={`/p/dashboard${rest || "/home"}${search}${hash}`} replace />;
}
import { DevViewModeSwitch } from "../dev/viewMode";
import Sidenav from "../Components/SideNav/SideNav";
const Orders = lazy(() => import("../Components/Orders/Orders"));
const OrdersV2Page = lazy(() => import("../features/ordersV2/OrdersV2Page"));
const PackageOrderDetailsPage = lazy(() =>
  import("../Components/Orders/orderDetailsPage/PackageOrderDetailsPage")
);
const HotelOrderDetailsPage = lazy(() =>
  import("../Components/Orders/orderDetailsPage/HotelOrderDetailsPage")
);
const DynamicPackageOrderDetailsPage = lazy(() =>
  import("../Components/Orders/orderDetailsPage/DynamicPackageOrderDetailsPage")
);
import Login from "../Pages/Client/Login/login";
import LoginVerifyPage from "../Pages/Client/LoginVerify/LoginVerifyPage";
const HotelProfile = lazy(() => import("../Pages/Client/HotelProfile/hotelprofile"));
const CustomerOfferPage = lazy(() => import("../Pages/Client/CustomerOffer/CustomerOfferPage"));
import DashboardPage from "../Pages/Dashboard/DashboardPage/DashboardPage";
import HrCommissionOrdersPage from "../Pages/Dashboard/HrCommissionOrdersPage/HrCommissionOrdersPage";
import SalesLinks from "../Pages/Agent/SalesLinks/SalesLinks";
import CruisePayment from "../Pages/Agent/CruisePayment/CruisePayment";
const PriceOffer = lazy(() => import("../Pages/Agent/PriceOffer/priceoffer"));
import UpperNavBarClient from "../Components/Client/UpperNavBarClient/uppernavbarclient";
import UpperNavBarAgent from "../Components/Agent/NavBarAgent/UpperNavBarAgent/uppernavbaragent";
import { isAuthenticated, getUserDetails } from "../services/authService";
import { getSideBarStatus } from "../services/localStorage";
// import TermsAndConditions from "../Pages/TermsAndConditions/TermsAndConditions";
import Registration from "../Components/Registration/Registration";
import AgentRegisterBillingReturn from "../Components/Registration/AgentRegisterBillingReturn";
import SubscriptionBillingPage from "../Components/Registration/SubscriptionBillingPage";
import { RegistrationProvider } from "../contexts/RegistrationContext";
import { PublicSiteProvider } from "../features/vacationPackagesPublic/PublicSiteContext";
import PublicPageScrollReset from "../features/vacationPackagesPublic/PublicPageScrollReset";
import { Loader } from "../Components/Loader/Loader";
import CustomLoading from "../Components/GeneralComponents/CustomLoading/customloading";
import Main from "../Pages/Main/MainPage";
import { resolveLegacyLdsHypPaymentHomeRedirect } from "../utils/ldsHypPaymentRoutes";
const Admin = lazy(() => import("../Pages/Admin/Admin"));
import { AgentTerms, TermsAndConditions } from "../Pages/AgentTerms/AgentTerms";
import SavedToursProfile from "../Pages/Client/OrganizedTourProfile/SavedToursProfile";
import { buildPublicPageCanonicalHref } from "../utils/resolvePublicBaseUrl";
import OrganizedTourLegacyProfileRedirect from "../Pages/Client/OrganizedTourProfile/OrganizedTourLegacyProfileRedirect";
import OrganizedTourLegacyDealProfileRedirect from "../Pages/Client/OrganizedTourProfile/OrganizedTourLegacyDealProfileRedirect";
const OrganizedTourProfileRoute = lazy(() =>
  import("../modules/organizedTours/pages/OrganizedTourProfilePage")
);
const OrganizedToursSearchPage = lazy(() =>
  import("../modules/organizedTours/pages/OrganizedToursSearchPage")
);
const OrganizedToursResultsPage = lazy(() =>
  import("../modules/organizedTours/pages/OrganizedToursResultsPage")
);
const OrganizedTourPaymentPage = lazy(() =>
  import("../modules/organizedTours/pages/OrganizedTourPaymentPage")
);
const OrganizedTourBookingPage = lazy(() =>
  import("../modules/organizedTours/pages/OrganizedTourBookingPage")
);
import OrganizedToursKeyedOutlet from "../modules/organizedTours/pages/OrganizedToursKeyedOutlet";
import SearchPackagesToSearchOfferRedirect from "../Components/Agent/NavBarAgent/SearchPackagesToSearchOfferRedirect";
import TourResultsLegacyDashboardRedirect from "../Components/Agent/NavBarAgent/TourResultsLegacyDashboardRedirect";
import Management from "../Pages/Management/Management";
import AgentPackageUpgradePage from "../Pages/Management/AgentPackageUpgradePage";
import { LoaderModal } from "../Components/Loader/LoaderModal";
import { useAppContext } from "../contexts/AppContext";
import { RemindersHubProvider } from "../features/reminders/context/RemindersHubContext";
import RemindersChrome from "../features/reminders/components/RemindersChrome";
import {
  AgentBillingStatusProvider,
  useAgentBillingStatus,
} from "../contexts/AgentBillingStatusContext";
import { AgentAccountOverviewProvider } from "../contexts/AgentAccountOverviewContext";
import { OperationRequestProvider } from "../features/operationRequest/OperationRequestUiContext";
import BillingMigrationGateModal from "../Components/Agent/BillingMigrationGate/BillingMigrationGateModal";
import BillingLockedView from "../Components/Agent/BillingMigrationGate/BillingLockedView";
const PriceOfferComponent = lazy(() => import("../Components/Agent/PriceOfferComponent/priceoffercomponent"));
import { Helmet } from "react-helmet";
import { useSelectedResult } from "../contexts/SelectedResultContext";
import PassengerMano from "../Components/mano/PassengerMano/PassengerMano";
import FooterSection from "../Components/FooterSection";
import "../features/agentDashboardShell/agentDashboardShell.css";
import AgentPackagesResultsChrome, {
  useIsPackagesResultsChromeActive,
} from "../features/packagesResultsView/AgentPackagesResultsChrome";
const FlightBookingPage = lazy(() => import("../Pages/Client/FlightBookingPage/FlightBookingPage"));
const AgentMiniSiteFlightBookingEntry = lazy(() =>
  import("../Pages/Agent/AgentMiniSite/AgentMiniSiteFlightBookingEntry")
);
import AgentFlightsBookingRootRedirect from "./AgentFlightsBookingRootRedirect";
const AgentMiniSite = lazy(() => import("../Pages/Agent/AgentMiniSite/AgentMiniSite"));
const VacationPackagesPage = lazy(() => import("../Pages/Client/VacationPackages/VacationPackagesPage"));
const BelvedereHotelLandingPage = lazy(() =>
  import("../Pages/campaigns/BelvedereHotelLandingPage.jsx")
);
const RoyalTulipTbilisiLandingPage = lazy(() =>
  import("../Pages/campaigns/RoyalTulipTbilisiLandingPage.jsx")
);
const RoyalZanzibarBeachResortLandingPage = lazy(() =>
  import("../Pages/campaigns/RoyalZanzibarBeachResortLandingPage.jsx")
);
const BelvedereCampaignPaymentSuccessPage = lazy(() =>
  import("../Pages/campaigns/BelvedereCampaignPaymentSuccessPage.jsx")
);
const BelvedereCampaignPaymentPage = lazy(() =>
  import("../Pages/campaigns/BelvedereCampaignPaymentPage.jsx")
);
const BelvedereCampaignOfferPage = lazy(() =>
  import("../Pages/campaigns/BelvedereCampaignOfferPage.jsx")
);
const Finance = lazy(() => import("../Components/Finance/Finance"));
const PaymentAgent = lazy(() => import("../Components/Agent/PaymentAgent/paymentagent"));
const SuccessOrder = lazy(() => import("../Components/Agent/PaymentAgent/SuccessOrder/successorder"));
const SavedPackagesProfile = lazy(() =>
  import("../Pages/Client/PackagesProfile/SavedPackageProfile")
);
const UnsavedPackagesProfile = lazy(() =>
  import("../Pages/Client/PackagesProfile/UnsavedPackagesProfile")
);
const PackageOrderSuccessPage = lazy(() =>
  import("../Pages/Client/PackagesProfile/PackageOrderSuccessPage").then((module) => ({
    default: module.default,
  }))
);
const LegacyPackagesSuccessRedirect = lazy(() =>
  import("../Pages/Client/PackagesProfile/PackageOrderSuccessPage").then((module) => ({
    default: module.LegacyPackagesSuccessRedirect,
  }))
);
const LdsHypPaymentOutcomePage = lazy(() =>
  import("../Pages/Client/Payment/LdsHypPaymentOutcomePage")
);
import GoogleReviewsPanel from "../Components/GoogleReviewsPanel/GoogleReviewsPanel";
import ErrorBoundary from "../Components/ErrorBoundary/ErrorBoundary";
import NotFound from "../Pages/NotFound/NotFound";
import FlightBookingMockupStandalonePage from "../Pages/Agent/FlightBookingMockupStandalonePage";
import FlightEngineV2PreviewStandalonePage from "../Pages/Agent/FlightEngineV2PreviewStandalonePage";
import HotelsResultsMockupStandalonePage from "../Pages/Agent/HotelsResultsMockupStandalonePage";
import HotelProfileMockupStandalonePage from "../Pages/Agent/HotelProfileMockupStandalonePage";
import HubwayzHotelPreviewStandalonePage from "../Pages/Agent/HubwayzHotelPreviewStandalonePage";
import HubwayzHotelOfferPreviewPage from "../features/hubwayzHotelPreview/HubwayzHotelOfferPreviewPage";
import UnifiedSearchMockupStandalonePage from "../Pages/Agent/UnifiedSearchMockupStandalonePage";
import HotelsSearchMockupStandalonePage from "../Pages/Agent/HotelsSearchMockupStandalonePage";
import HubwayzHotelBookingPage from "../features/hubwayzHotelsTab/HubwayzHotelBookingPage";
import ReservationDetailsV2PreviewPage from "../Pages/Agent/ReservationDetailsV2PreviewPage";
import FlightProposalAgentPage from "../Pages/Agent/FlightProposal/FlightProposalAgentPage";
import {
  FlightOfferUiProvider,
} from "../contexts/FlightOfferUiContext";
import { isFlightsNewProposalPackage } from "../utils/dynamicPackageDisplayMode";
import Customers from "../Pages/Agent/Customers/Customers";
import AISalesLeadsRoute from "../Pages/Agent/AISalesLeads/AISalesLeadsRoute";
import CustomerChatInboxPage from "../Pages/Agent/CustomerChatInbox/CustomerChatInboxPage";
import Reports from "../Pages/Agent/Reports/Reports";
import Academy from "../Pages/Agent/Academy/Academy";
import RemindersPage from "../Pages/Dashboard/Reminders/RemindersPage";
import AgentMyOperationRequestsPage from "../Pages/Dashboard/OperationRequests/AgentMyOperationRequestsPage";
import AgentOperationRequestDetailPage from "../features/operationRequest/pages/AgentOperationRequestDetailPage";
import NewOperationRequestPage from "../features/operationRequest/pages/NewOperationRequestPage";
import AgentSeoSettingsPage from "../Pages/Agent/SeoSettings/AgentSeoSettingsPage";
import AgentSeoArticlesPage from "../Pages/Agent/SeoArticles/AgentSeoArticlesPage";
import PaymentMethodVaultReturn from "../Pages/Agent/PaymentMethodVaultReturn/PaymentMethodVaultReturn";
import SubscriptionPaymentSuccessPage from "../Pages/Agent/SubscriptionPaymentSuccess/SubscriptionPaymentSuccessPage";
import SiteSettingsPage from "../Pages/AgentDashboard/SiteSettingsPage";
import { AgentPublicSiteGate } from "../features/agentEntitlements/AgentPublicSiteGate.jsx";
import { EntitlementGate } from "../features/agentEntitlements/EntitlementGate.jsx";
import ContactPage from "../Pages/Client/Contact/ContactPage";
import CustomerChatPublicStartPage from "../Pages/Client/CustomerChatPublic/CustomerChatPublicStartPage";
import PublicOfferLinkPage from "../Pages/Client/PublicOffer/PublicOfferLinkPage";
const ManoQuotePublicPage = lazy(() =>
  import("../Pages/Client/ManoQuotePublic/ManoQuotePublicPage")
);
const ManoPassportUploadPublicPage = lazy(() =>
  import("../Pages/Client/ManoPassportUpload/ManoPassportUploadPublicPage")
);
const ManoQuotesListPage = lazy(() =>
  import("../Pages/Agent/ManoQuotes/ManoQuotesListPage")
);
const ManoQuoteWizardPage = lazy(() =>
  import("../Pages/Agent/ManoQuotes/ManoQuoteWizardPage")
);
const ManoQuoteViewPage = lazy(() =>
  import("../Pages/Agent/ManoQuotes/ManoQuoteViewPage")
);
const ManoPassportUploadsPage = lazy(() =>
  import("../Pages/Agent/ManoQuotes/ManoPassportUploadsPage")
);
import DevOfferRenderersGalleryPage from "../Pages/Client/PublicOffer/DevOfferRenderersGalleryPage";
import PublicSeoArticlePage from "../Pages/Client/Blog/PublicSeoArticlePage";
import SecureClient from "../Pages/Client/SecureClient/SecureClient";
import LoaderPreviewPage from "../Pages/LoaderPreviewPage";
import DevCustomerServiceRequestsRoute from "../features/agentServiceRequests/DevCustomerServiceRequestsRoute";
const CustomerPortalShell = lazy(() => import("../features/customerPortal/CustomerPortalShell"));
const PublicBookingConfirmationPage = lazy(() =>
  import("../features/publicBookingConfirmation/PublicBookingConfirmationPage")
);
const PublicBookingAccessPage = lazy(() =>
  import("../features/publicBookingConfirmation/PublicBookingAccessPage")
);
const PublicBookingViewPage = lazy(() =>
  import("../features/publicBookingConfirmation/PublicBookingViewPage")
);
const PublicBookingSuccessPreviewPage = lazy(() =>
  import("../features/publicBookingConfirmation/PublicBookingSuccessPreviewPage")
);
const Countries = lazy(() => import("../Pages/Admin/Countries/Countries"));
const Tournaments = lazy(() => import("../Pages/Admin/Tournaments/Tournaments"));
import DashboardPublicRedirect from "./DashboardPublicRedirect";
import FlightsBookingRootRedirect from "./FlightsBookingRootRedirect";
import { RuntimeRouteTelemetry } from "../utils/debug/RuntimeRouteTelemetry";
import MetaPixelRouteTracker from "../utils/metaPixel/MetaPixelRouteTracker";
import HotelsRiverChatGate from "../features/chat/HotelsRiverChatGate";
import SeoMetaGuardRuntimeBridge from "../seo/SeoMetaGuardRuntimeBridge";
import ZoomOnePagerPage from "../Pages/Agent/ZoomOnePager/ZoomOnePagerPage";
import DynamicPackagesMaintenanceRouteGate from "../features/dynamicPackagesMaintenance/DynamicPackagesMaintenanceRouteGate.jsx";
import DynamicPackagesMaintenanceWall from "../features/dynamicPackagesMaintenance/DynamicPackagesMaintenanceWall.jsx";
import { LocaleAwarePublicRoutes } from "./LocaleShell";
import { useLocalePath } from "../contexts/LocalePathContext";
import { ProductContextProvider, useProductContext } from "../i18n/providers/ProductContextProvider";
import RouteLocaleSync, { AgentDashboardLocalePolicy } from "../i18n/providers/RouteLocaleSync";
import InternationalDashboardLayout from "../i18n/layouts/InternationalDashboardLayout";
import InternationalAgentDashboardBodyRoutes from "./InternationalAgentDashboardBodyRoutes";
import SecureAgentDashboardGate from "./SecureAgentDashboardGate";
const CompanyLoginPage = lazy(() => import("../features/corporate/pages/CompanyLoginPage"));
const CompanyLoginVerifyPage = lazy(() =>
  import("../features/corporate/pages/CompanyLoginVerifyPage"),
);
const CompanyRegisterPage = lazy(() => import("../features/corporate/pages/CompanyRegisterPage"));
const CompanyForgotPasswordPage = lazy(() =>
  import("../features/corporate/pages/CompanyForgotPasswordPage")
);
const CompanyResetPasswordPage = lazy(() =>
  import("../features/corporate/pages/CompanyResetPasswordPage")
);
const CompanyPendingApprovalPage = lazy(() =>
  import("../features/corporate/pages/CompanyPendingApprovalPage")
);
const CorporateEmployeeInvitationPage = lazy(() =>
  import("../features/corporate/pages/CorporateEmployeeInvitationPage")
);
import { corporatePortalRoute } from "../features/corporate/routes/CorporateRouteBranch";
import { CORPORATE_ROUTES } from "../features/corporate/constants/corporateConstants";
import HotelProfilePublicRouteEntry from "./HotelProfilePublicRouteEntry";
import WelcomePage from "../Pages/Gateway/WelcomePage";
import TripMasterAppRoutes from "../surfaces/tripMaster/TripMasterAppRoutes";
import { isTripMasterSurface } from "../surfaces/tripMaster/tripMasterEnv";

function RouteChunkSuspense({ label, children }) {
  return (
    <ErrorBoundary>
      <Suspense fallback={<CustomLoading label={label} overlay size="large" />}>{children}</Suspense>
    </ErrorBoundary>
  );
}

function LazyAdminRoute() {
  return (
    <RouteChunkSuspense label="טוען ממשק ניהול...">
      <Admin />
    </RouteChunkSuspense>
  );
}

/** כופה remount לפי `:category` כדי ש־`Orders` לא יישאר עם `currentTabIndex` מהמסלול הקודם. */
function OrdersRouteWrapper() {
  const { category } = useParams();
  // G.4E — legacy Dynamic list route: redirect to Orders V2 (no product switch).
  if (String(category || "").trim().toLowerCase() === "dynamic-packages") {
    return <Navigate to="/p/dashboard/orders" replace />;
  }
  return (
    <RouteChunkSuspense label="טוען הזמנות...">
      <Orders key={category || "orders"} />
    </RouteChunkSuspense>
  );
}

/** Legacy searchdynamic / Dynamic detail → product-unavailable wall (G.4E). */
function DynamicProductInactivePage() {
  return <DynamicPackagesMaintenanceWall />;
}

const MemoChildren = React.memo(function MemoChildren({ children }) {
  return children;
});

/** מאזין גלובלי: פיצ׳רים נעולים שולחים upgrade_flow גם מתוך מסכים שאינם AgentDashboardChrome. */
const AgentUpgradeFlowListener = React.memo(function AgentUpgradeFlowListener() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => {
      const u = typeof getUserDetails === "function" ? getUserDetails() : null;
      const ut = String(u?.usertype ?? u?.userType ?? "").toLowerCase();
      if (ut !== "agents" && ut !== "agent") {
        return;
      }
      if (import.meta.env.DEV) {
        console.log("[UPGRADE_ROUTE_RESOLVE]", {
          to: "/p/dashboard/management/upgrade",
          scope: "global_agent_listener",
        });
      }
      navigate("/p/dashboard/management/upgrade");
    };

    if (typeof window !== "undefined") {
      window.addEventListener("upgrade_flow", handler);
    }
    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("upgrade_flow", handler);
      }
    };
  }, [navigate]);

  return null;
});

const AttractionsCatalogPage = lazy(() =>
  import("../Pages/Client/Attractions/AttractionsCatalogPage")
);
const AttractionPublicPage = lazy(() =>
  import("../Pages/Client/Attractions/AttractionPublicPage")
);

function MainEntry() {
  const [searchParams] = useSearchParams();
  const legacyTarget = resolveLegacyLdsHypPaymentHomeRedirect(searchParams);
  if (legacyTarget) {
    return <Navigate to={legacyTarget} replace />;
  }
  return <Main />;
}

function WelcomeRootEntry() {
  const user = getUserDetails();
  const hasPersistedSession = Boolean(user && (user.sessionID || user.sessionId));
  const userType = String(user?.usertype || user?.userType || "").toLowerCase();

  if (hasPersistedSession) {
    if (userType === "clients" || userType === "client") {
      return <Navigate to="/p/dashboard/home" replace />;
    }

    return <Navigate to="/p/dashboard" replace />;
  }

  return <WelcomePage />;
}

export const ROUTES = {
  TERMS_AND_CONDITIONS: "termsAndConditions",
  AGENT_TERMS: "agentTerms",
  LOGIN: "login",
  MAIN: "",
  PACKAGE_PROFILE: "packages/profile",
  /** @deprecated Use `/packages/profile/:id/success` — kept for redirect */
  ORDER_SUCCESS: "packages/success",
  /** @deprecated — use dashboard `/p/dashboard/organized-tours/profile/:dealId` */
  TOURE_PROFILE: "tour/profile",
  ORGANIZED_TOURS_RESULTS: "organized-tours/results",
  ORGANIZED_TOURS_PROFILE: "organized-tours/profile",
  TOUR_SUCCESS: "tour/success",
  HOTEL_OFFER: "hotel/offer",
  HOTEL_PROFILE: "hotel/profile",
  HOTEL_SUCCESS: "hotel/success",
  DYNAMIC_OFFER: "dynamic/offer",
  /** ציבורי: הצעת טיסה בלבד (flights_new) — namespace נפרד מ־dynamic/offer */
  FLIGHTS_OFFER: "flights/offer",
  DYNAMIC_PROFILE: "dynamic/profile",
  DYNAMIC_SUCCESS: "dynamic/success",
  /** Agent: flights_new / flight-only proposal view (shareable within dashboard) */
  PACKAGES_FLIGHT_PROPOSAL: "packages/proposal",
  FLIGHT_BOOKING: "flights/booking",
  FLIGHT_PROFILE: "flights/profile",
  AGENT_MINI_SITE: "agent",
  VACATION_PACKAGES: "vacation-packages",
  VACATION_PACKAGES_DESTINATION: "vacation-packages/destination",
  VACATION_PACKAGE_DETAIL: "vacation-packages/package",
  /** פרופיל חבילה דינמית (נפרד מ־/hotelprofile) */
  DYNAMIC_PACKAGE_PROFILE: "dynamic-package-profile",
  /** עמוד מכירה פרימיום ללקוח — מבנה זהה, ללא כלי סוכן */
  CUSTOMER_DYNAMIC_PACKAGE_OFFER: "offer/dynamic-package",
  /** כינוי ציבורי — redirect ל־VACATION_PACKAGES */
  PACKAGES_SEARCH_ALIAS: "packages/search",
  /** Legacy URL only — מפנה ל־vacation-packages; אין עוד FlightBookingPage ב־/flights/search */
  FLIGHTS_SEARCH_ALIAS: "flights/search",
  FLIGHTS_RESULTS: "flights/results",
  FLIGHTS_REVIEW: "flights/review",
  /** הצעת חבילה ציבורית לפי token (snapshot מהשרת) */
  PUBLIC_OFFER_PAGE: "offers/public",
  /** פורטל לקוח — צפייה בהזמנה לפי פרטי ההזמנה */
  CUSTOMER_ORDER_PORTAL: "customer-portal",
  PUBLIC_BOOKING_CONFIRMATION: "booking/confirmation",
  PUBLIC_BOOKING_ACCESS: "booking/access",
  PUBLIC_BOOKING_VIEW: "booking/view",
  /** קטלוג אטרקציות ציבורי + דף נחיתה לכל אטרקציה */
  ATTRACTIONS: "attractions",
  CAMPAIGN_BELVEDERE: "campaigns/royal-belvedere-2026",
  CAMPAIGN_ROYAL_TULIP: "campaigns/royal-tulip-tbilisi-2026",
  CAMPAIGN_ROYAL_ZANZIBAR: "campaigns/royal-zanzibar-beach-resort-2026",
  CAMPAIGN_TEMBO_KIWENGWA: "campaigns/tembo-kiwengwa-resort-2026",
  CAMPAIGN_ZANZIBELLA: "campaigns/zanzibella-hotel-spa-2026",
};

/** Morning subscription success — explicit /he/ route before path="/*" so deep links never hit NotFound. */
function SubscriptionPaymentSuccessEntry() {
  return (
    <div className="client-pages subscription-payment-success">
      <div className="client-component-fullscreen">
        <SubscriptionPaymentSuccessPage />
      </div>
    </div>
  );
}

const InnerRoutes = () => {
  const [hotelName, setHotelName] = useState("");
  if (import.meta.env.DEV && typeof window !== "undefined" && window.DEBUG_MODE) {
    console.count("[RENDER_TRACE] ROOT");
  }

  const handleHotelName = (name) => {
    setHotelName(name);
  };

  const DynamicPackageProfileEntry = () => (
    <HotelProfile handleHotelName={handleHotelName} packageExperience />
  );

  const CustomerDynamicOfferEntry = () => (
    <CustomerOfferPage handleHotelName={handleHotelName} />
  );

  const PublicClientRoutes = () => {
    const [showNavBar, setShowNavBar] = useState(true);
    const { isAppLoggedIn } = useAppContext();
    const { dynamicOrder } = useSelectedResult();
    const location = useLocation();
    const { toAppPathname } = useLocalePath();
    const appPathname = toAppPathname(location.pathname);
    const isPublicVacationPackagesPath =
      appPathname === `/${ROUTES.VACATION_PACKAGES}` ||
      appPathname.startsWith(`/${ROUTES.VACATION_PACKAGES_DESTINATION}/`) ||
      appPathname.startsWith(`/${ROUTES.VACATION_PACKAGE_DETAIL}/`);
    const routesLocation = React.useMemo(
      () => ({
        ...location,
        pathname: appPathname,
        key: isPublicVacationPackagesPath ? appPathname : location.key,
      }),
      [appPathname, isPublicVacationPackagesPath, location]
    );

    useEffect(() => {
      if (!isAppLoggedIn() && appPathname !== "/") {
        setShowNavBar(false);
      } else if (appPathname === "/") {
        setShowNavBar(true);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appPathname]); // Only depend on app pathname to avoid infinite loop

    const isLoginPage =
      appPathname === "/login" ||
      appPathname === "/login/verify" ||
      appPathname.startsWith("/passwordreset") ||
      appPathname === "/registeragent" ||
      appPathname === "/registeragent/billing" ||
      appPathname.startsWith("/registeragent/billing/") ||
      appPathname.startsWith("/register/agent/");

    // Hide navbar for vacation packages page and package detail page (כולל כינוי legacy לפני redirect)
    const isVacationPackagesPage =
      appPathname === `/${ROUTES.VACATION_PACKAGES}` ||
      appPathname.startsWith(`/${ROUTES.VACATION_PACKAGES_DESTINATION}/`) ||
      appPathname.startsWith(`/${ROUTES.VACATION_PACKAGE_DETAIL}/`) ||
      appPathname === "/vacation_packages" ||
      appPathname.startsWith("/vacation_packages/");
    // Hide navbar for agent mini site (it's handled within the component)
    const isAgentMiniSite = appPathname.includes(`/${ROUTES.AGENT_MINI_SITE}/`);
    const isCustomerChatPublic =
      appPathname === "/customer-chat/start" ||
      appPathname.startsWith("/customer-chat/");
    const isPublicOfferLinkPage = appPathname.startsWith("/offers/public/");
    /** עמוד ציבורי — הצעת מחיר מנו ספנות לפי token (ללא chrome) */
    const isManoQuotePublicPage = appPathname.startsWith("/q/mano/");
    /** עמוד ציבורי — העלאת דרכונים להזמנת מנו */
    const isManoPassportUploadPublicPage = appPathname.startsWith("/q/mano-passports/");
    const isZoomOnePager = appPathname === "/zoom/agents-transition";
    const isCustomerPortal =
      appPathname === `/${ROUTES.CUSTOMER_ORDER_PORTAL}` ||
      appPathname.startsWith(`/${ROUTES.CUSTOMER_ORDER_PORTAL}/`);
    const isPublicBookingConfirmation =
      appPathname === "/booking" ||
      appPathname.startsWith("/booking/") ||
      (import.meta.env.DEV && appPathname === "/dev/public-booking-success-preview");
    const isDevServiceRequestsMock =
      import.meta.env.DEV && appPathname === "/dev/customer-service-requests";
    const isPackagesPaymentMockup =
      appPathname === "/dev/packages-payment-mockup" ||
      appPathname === "/p/dashboard/packages-payment-mockup" ||
      appPathname.endsWith("/packages-payment-mockup");
    const isPackagesResultsMockup =
      appPathname === "/dev/packages-results-mockup" ||
      appPathname === "/p/dashboard/packages-results-mockup" ||
      appPathname.endsWith("/packages-results-mockup");
    const isHotelsResultsMockup =
      appPathname === "/dev/hotels-results-mockup" ||
      appPathname === "/p/dashboard/hotels-results-mockup" ||
      appPathname.endsWith("/hotels-results-mockup");
    const isHotelProfileMockup =
      appPathname === "/dev/hotel-profile-mockup" ||
      appPathname === "/p/dashboard/hotel-profile-mockup" ||
      appPathname.endsWith("/hotel-profile-mockup");
    const isHubwayzHotelPreview =
      appPathname === "/dev/hotel-preview" ||
      appPathname === "/p/dashboard/hotel-preview" ||
      appPathname.endsWith("/hotel-preview") ||
      appPathname === "/dev/hotel-offer-preview" ||
      appPathname === "/p/dashboard/hotel-offer-preview" ||
      appPathname.endsWith("/hotel-offer-preview");
    const isUnifiedSearchMockup =
      appPathname === "/dev/unified-search-mockup" ||
      appPathname === "/p/dashboard/unified-search-mockup" ||
      appPathname.endsWith("/unified-search-mockup");
    const isHotelsSearchMockup =
      appPathname === "/dev/hotels-search-mockup" ||
      appPathname === "/p/dashboard/hotels-search-mockup" ||
      appPathname.endsWith("/hotels-search-mockup");
    const isBookingConfirmationMockup =
      appPathname === "/dev/booking-confirmation-mockup" ||
      appPathname === "/p/dashboard/booking-confirmation-mockup" ||
      appPathname.endsWith("/booking-confirmation-mockup");
    const isLoginMonthlyMockup =
      appPathname === "/dev/login-monthly-mockup" ||
      appPathname.endsWith("/login-monthly-mockup");
    const isReservationDetailsV2Preview =
      appPathname === "/dev/reservation-details-v2-preview" ||
      appPathname.endsWith("/reservation-details-v2-preview");
    const [searchParams] = useSearchParams();
    const isSavedPackageProfilePath = /\/packages\/profile\/(?!draft\/)[^/]+\/?$/.test(
      appPathname
    );
    const hideChromeForCustomerQuoteOffer =
      isSavedPackageProfilePath && searchParams.get("offer") === "1";

    /** פרופיל חבילה דינמית / הצעת לקוח — מחלקה ל־App.css לפני mount של HotelProfile (Suspense) כדי שלא ייווצר scroll פנימי ב־.client-component */
    const isDynamicPackageHotelProfilePath =
      appPathname.startsWith(`/${ROUTES.DYNAMIC_PACKAGE_PROFILE}/`) ||
      appPathname.startsWith(`/${ROUTES.CUSTOMER_DYNAMIC_PACKAGE_OFFER}/`);

    /** פרופיל הזמנת חבילות (/packages/profile, /packages/profile/:id, draft, success) — אותו scroll פנימי ששובר sticky בסיכום צד */
    const packagesProfilePathPrefix = `/${ROUTES.PACKAGE_PROFILE}`;
    const isPackagesProfilePath =
      appPathname === packagesProfilePathPrefix ||
      appPathname.startsWith(`${packagesProfilePathPrefix}/`);
    /** Unsaved live agent profile only (`PackageProfileLiveShell` / hpmShell) — skip classic UpperNavBarClient */
    const isUnsavedPackagesProfilePath =
      appPathname === packagesProfilePathPrefix ||
      appPathname === `${packagesProfilePathPrefix}/`;
    const isBelvedereCampaignPath =
      appPathname === `/${ROUTES.CAMPAIGN_BELVEDERE}` ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_BELVEDERE}/`) ||
      appPathname === `/${ROUTES.CAMPAIGN_ROYAL_TULIP}` ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ROYAL_TULIP}/`) ||
      appPathname === `/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}` ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}/`) ||
      appPathname === `/${ROUTES.CAMPAIGN_TEMBO_KIWENGWA}` ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_TEMBO_KIWENGWA}/`) ||
      appPathname === `/${ROUTES.CAMPAIGN_ZANZIBELLA}` ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ZANZIBELLA}/`);
    const isBelvedereCustomerImmersivePath =
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_BELVEDERE}/payment`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_BELVEDERE}/offer`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ROYAL_TULIP}/payment`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ROYAL_TULIP}/offer`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}/payment`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}/offer`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_TEMBO_KIWENGWA}/payment`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_TEMBO_KIWENGWA}/offer`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ZANZIBELLA}/payment`) ||
      appPathname.startsWith(`/${ROUTES.CAMPAIGN_ZANZIBELLA}/offer`);
    const isLdsHypPaymentOutcomePath =
      appPathname.startsWith("/payment/success/lds/") ||
      appPathname.startsWith("/payment/fail/lds/") ||
      appPathname.startsWith("/payment/cancel/lds/");
    const isSubscriptionPaymentSuccessPath =
      appPathname === "/subscription-payment-success";

    return (
      <div
        className={
          "client-pages " +
          appPathname.split("/").pop() +
          (isDevServiceRequestsMock ? " client-pages--service-requests-mock" : "") +
          (isPackagesPaymentMockup ? " client-pages--packages-payment-mockup" : "") +
          (isPackagesResultsMockup ? " client-pages--packages-results-mockup" : "") +
          (isHotelsResultsMockup ? " client-pages--hotels-results-mockup" : "") +
          (isHotelProfileMockup ? " client-pages--hotels-profile-mockup" : "") +
          (isHubwayzHotelPreview ? " client-pages--hubwayz-hotel-preview" : "") +
          (isUnifiedSearchMockup ? " client-pages--unified-search-mockup" : "") +
          (isHotelsSearchMockup ? " client-pages--hotels-search-mockup" : "") +
          (isBookingConfirmationMockup
            ? " client-pages--booking-confirmation-mockup"
            : "") +
          (isLoginMonthlyMockup ? " client-pages--login-monthly-mockup" : "") +
          (isReservationDetailsV2Preview ? " client-pages--reservation-details-v2" : "") +
          (hideChromeForCustomerQuoteOffer ? " client-pages--package-offer-quote" : "") +
          (isUnsavedPackagesProfilePath ? " client-pages--packages-profile-hpm" : "") +
          (isPublicBookingConfirmation ? " client-pages--public-booking" : "")
        }
      >
        <PublicPageScrollReset />
        {showNavBar &&
          !isVacationPackagesPage &&
          !isAgentMiniSite &&
          !isCustomerChatPublic &&
          !isPublicOfferLinkPage &&
          !isManoQuotePublicPage &&
          !isManoPassportUploadPublicPage &&
          !isZoomOnePager &&
          !isCustomerPortal &&
          !isPublicBookingConfirmation &&
          !isDevServiceRequestsMock &&
          !isPackagesPaymentMockup &&
          !isPackagesResultsMockup &&
          !isHotelsResultsMockup &&
          !isHotelProfileMockup &&
          !isHubwayzHotelPreview &&
          !isUnifiedSearchMockup &&
          !isHotelsSearchMockup &&
          !isBookingConfirmationMockup &&
          !isLoginMonthlyMockup &&
          !isReservationDetailsV2Preview &&
          !hideChromeForCustomerQuoteOffer &&
          !isUnsavedPackagesProfilePath &&
          !isLdsHypPaymentOutcomePath &&
          !isSubscriptionPaymentSuccessPath &&
          !isBelvedereCustomerImmersivePath && <UpperNavBarClient hotelName={hotelName} />}

        <div
          className={
            isLoginPage ||
            isCustomerPortal ||
            isPublicBookingConfirmation ||
            isDevServiceRequestsMock ||
            isPackagesPaymentMockup ||
            isPackagesResultsMockup ||
            isHotelsResultsMockup ||
            isHotelProfileMockup ||
            isHubwayzHotelPreview ||
            isUnifiedSearchMockup ||
            isHotelsSearchMockup ||
            isBookingConfirmationMockup ||
            isLoginMonthlyMockup ||
            isReservationDetailsV2Preview ||
            isLdsHypPaymentOutcomePath ||
            isSubscriptionPaymentSuccessPath ||
            isUnsavedPackagesProfilePath ||
            hideChromeForCustomerQuoteOffer
              ? "client-component-fullscreen"
              : [
                  "client-component",
                  isDynamicPackageHotelProfilePath ? "client-component--dp-profile-scroll" : "",
                  isPackagesProfilePath ? "client-component--packages-profile-scroll" : "",
                  isBelvedereCampaignPath ? "client-component--belvedere-scroll" : "",
                ]
                  .filter(Boolean)
                  .join(" ")
          }
        >
          <ErrorBoundary>
          <Routes location={routesLocation}>
            <Route path="/" element={<MainEntry />} />
            <Route
              path="/payment/success/lds/:orderId"
              element={
                <Suspense fallback={<CustomLoading label="טוען אישור תשלום..." overlay size="large" />}>
                  <LdsHypPaymentOutcomePage />
                </Suspense>
              }
            />
            <Route
              path="/payment/fail/lds/:orderId"
              element={
                <Suspense fallback={<CustomLoading label="טוען..." overlay size="large" />}>
                  <LdsHypPaymentOutcomePage />
                </Suspense>
              }
            />
            <Route
              path="/payment/cancel/lds/:orderId"
              element={
                <Suspense fallback={<CustomLoading label="טוען..." overlay size="large" />}>
                  <LdsHypPaymentOutcomePage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.FLIGHTS_SEARCH_ALIAS}`}
              element={<FlightsSearchPublicLegacyRedirect />}
            />
            <Route
              path={`/${ROUTES.FLIGHTS_RESULTS}`}
              element={
                <Suspense fallback={<CustomLoading label="טוען טיסות..." overlay size="large" />}>
                  <FlightBookingPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.FLIGHTS_REVIEW}`}
              element={
                <Suspense fallback={<CustomLoading label="טוען טיסות..." overlay size="large" />}>
                  <FlightBookingPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.PACKAGES_SEARCH_ALIAS}`}
              element={<Navigate to={`/${ROUTES.VACATION_PACKAGES}`} replace />}
            />
            <Route path="/login" element={<Login />} />
            <Route path="/login/verify" element={<LoginVerifyPage />} />
            <Route
              path={`/${ROUTES.CUSTOMER_ORDER_PORTAL}/*`}
              element={
                <Suspense fallback={<CustomLoading label="טוען פורטל הזמנה..." overlay size="large" />}>
                  <CustomerPortalShell />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.PUBLIC_BOOKING_ACCESS}`}
              element={
                <PublicSiteProvider>
                  <Suspense fallback={<CustomLoading label="טוען כניסה להזמנה..." overlay size="large" />}>
                    <PublicBookingAccessPage />
                  </Suspense>
                </PublicSiteProvider>
              }
            />
            <Route
              path={`/${ROUTES.PUBLIC_BOOKING_CONFIRMATION}/:orderRef`}
              element={
                <PublicSiteProvider>
                  <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
                    <PublicBookingConfirmationPage />
                  </Suspense>
                </PublicSiteProvider>
              }
            />
            <Route
              path={`/${ROUTES.PUBLIC_BOOKING_VIEW}/:orderRef`}
              element={
                <PublicSiteProvider>
                  <Suspense fallback={<CustomLoading label="טוען הזמנה..." overlay size="large" />}>
                    <PublicBookingViewPage />
                  </Suspense>
                </PublicSiteProvider>
              }
            />
            <Route path="/loader-preview" element={<LoaderPreviewPage />} />
            {import.meta.env.DEV ? (
              <>
                <Route
                  path="/dev/customer-service-requests"
                  element={<DevCustomerServiceRequestsRoute />}
                />
                <Route
                  path="/dev/offer-renderers-gallery"
                  element={<DevOfferRenderersGalleryPage />}
                />
                <Route
                  path="/dev/public-booking-success-preview"
                  element={
                    <PublicSiteProvider>
                      <Suspense fallback={<CustomLoading label="טוען הדמיית אישור..." overlay size="large" />}>
                        <PublicBookingSuccessPreviewPage />
                      </Suspense>
                    </PublicSiteProvider>
                  }
                />
                <Route
                  path="/dev/flight-engine-v2-preview"
                  element={<FlightEngineV2PreviewStandalonePage />}
                />
                <Route
                  path="/dev/hotels-results-mockup"
                  element={<HotelsResultsMockupStandalonePage />}
                />
                <Route
                  path="/dev/hotel-profile-mockup"
                  element={<HotelProfileMockupStandalonePage />}
                />
                <Route
                  path="/dev/hotel-preview"
                  element={<HubwayzHotelPreviewStandalonePage />}
                />
                <Route
                  path="/dev/hotel-offer-preview"
                  element={<HubwayzHotelOfferPreviewPage />}
                />
                <Route
                  path="/dev/hubwayz-hotel-preview"
                  element={<Navigate to="/dev/hotel-preview" replace />}
                />
                <Route
                  path="/dev/hubwayz-hotel-offer-preview"
                  element={<Navigate to="/dev/hotel-offer-preview" replace />}
                />
                <Route
                  path="/dev/unified-search-mockup"
                  element={<UnifiedSearchMockupStandalonePage />}
                />
                <Route
                  path="/dev/hotels-search-mockup"
                  element={<HotelsSearchMockupStandalonePage />}
                />
                <Route
                  path="/dev/reservation-details-v2-preview"
                  element={<ReservationDetailsV2PreviewPage />}
                />
              </>
            ) : null}
            <Route
              path={`/${ROUTES.PUBLIC_OFFER_PAGE}/:token`}
              element={<PublicOfferLinkPage />}
            />
            <Route
              path="/q/mano/:token"
              element={
                <Suspense fallback={<CustomLoading label="טוען הצעת מחיר..." overlay size="large" />}>
                  <ManoQuotePublicPage />
                </Suspense>
              }
            />
            <Route
              path="/q/mano-passports/:token"
              element={
                <Suspense fallback={<CustomLoading label="טוען העלאת דרכונים..." overlay size="large" />}>
                  <ManoPassportUploadPublicPage />
                </Suspense>
              }
            />
            <Route
              path="/:lang/offers/public/:token"
              element={<PublicOfferLinkPage />}
            />
            <Route path="/blog/:slug" element={<PublicSeoArticlePage />} />
            {/* Legacy ‎/a/:slug — הוסר; מפנה לקטלוג החבילות הציבורי */}
            <Route
              path="/a/*"
              element={<Navigate to={`/${ROUTES.VACATION_PACKAGES}`} replace />}
            />
            <Route
              path="/passwordreset/:resetToken"
              element={<Login resetPasssword />}
            />
            <Route
              path="/registeragent"
              element={
                <RegistrationProvider>
                  <Registration />
                </RegistrationProvider>
              }
            />
            <Route path="/registeragent/billing/return" element={<AgentRegisterBillingReturn />} />
            <Route path="/registeragent/billing" element={<SubscriptionBillingPage />} />
            <Route
              path="/subscription-payment-success"
              element={<SubscriptionPaymentSuccessPage />}
            />
            <Route
              path="/register/agent/billing-complete"
              element={<AgentRegisterBillingReturn />}
            />
            {/*<Route path="registeragent" element={<RegisterAgent />} />*/}
            <Route
              path={`/${ROUTES.TERMS_AND_CONDITIONS}`}
              element={
                // <div
                //   style={{
                //     height: "100vh",
                //     overflow: "auto",
                //     backgroundColor: "white",
                //   }}
                // >
                //   <TermsAndConditions />
                // </div>
                <TermsAndConditions />
              }
            />
            <Route path={`/${ROUTES.AGENT_TERMS}`} element={<AgentTerms />} />
            {/*<Route path={`/israelkabesa`} element={<PassengerMano totalPriceInILS={5000}/>} />*/}
            <Route
              path="hotelprofile/:hotelid"
              element={<HotelProfilePublicRouteEntry handleHotelName={handleHotelName} />}
            />
            <Route
              path="hotelprofile/:hotelid/hotel/:hotelOrderId"
              element={
                <Suspense fallback={<CustomLoading label="טוען חבילות / חדרים..." overlay size="large" />}>
                  <HotelProfile handleHotelName={handleHotelName} />
                </Suspense>
              }
            />
            <Route
              path="hotelprofile/:hotelid/dynamic/:dynamicOrderId"
              element={
                <Suspense fallback={<CustomLoading label="טוען חבילות / חדרים..." overlay size="large" />}>
                  <DynamicPackagesMaintenanceRouteGate gateTriggered="public_hotelprofile_dynamic">
                    <HotelProfile handleHotelName={handleHotelName} />
                  </DynamicPackagesMaintenanceRouteGate>
                </Suspense>
              }
            />
            <Route
              path={`${ROUTES.DYNAMIC_PACKAGE_PROFILE}/:hotelid`}
              element={
                <Suspense fallback={<CustomLoading label="טוען חבילת נופש..." overlay size="large" />}>
                  <DynamicPackagesMaintenanceRouteGate gateTriggered="public_dynamic_package_profile">
                    <DynamicPackageProfileEntry />
                  </DynamicPackagesMaintenanceRouteGate>
                </Suspense>
              }
            />
            <Route
              path={`${ROUTES.DYNAMIC_PACKAGE_PROFILE}/:hotelid/hotel/:hotelOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען חבילת נופש..." overlay size="large" />}>
                  <DynamicPackagesMaintenanceRouteGate gateTriggered="public_dynamic_package_profile_hotel_order">
                    <DynamicPackageProfileEntry />
                  </DynamicPackagesMaintenanceRouteGate>
                </Suspense>
              }
            />
            <Route
              path={`${ROUTES.DYNAMIC_PACKAGE_PROFILE}/:hotelid/dynamic/:dynamicOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען חבילת נופש..." overlay size="large" />}>
                  <DynamicPackagesMaintenanceRouteGate gateTriggered="public_dynamic_package_profile_dynamic_order">
                    <DynamicPackageProfileEntry />
                  </DynamicPackagesMaintenanceRouteGate>
                </Suspense>
              }
            />
            <Route
              path={`${ROUTES.CUSTOMER_DYNAMIC_PACKAGE_OFFER}/:hotelid`}
              element={
                <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
                  <DynamicPackagesMaintenanceRouteGate gateTriggered="public_customer_dynamic_package_offer">
                    <CustomerDynamicOfferEntry />
                  </DynamicPackagesMaintenanceRouteGate>
                </Suspense>
              }
            />
            <Route
              path={`${ROUTES.CUSTOMER_DYNAMIC_PACKAGE_OFFER}/:hotelid/hotel/:hotelOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
                  <DynamicPackagesMaintenanceRouteGate gateTriggered="public_customer_dynamic_package_offer_hotel_order">
                    <CustomerDynamicOfferEntry />
                  </DynamicPackagesMaintenanceRouteGate>
                </Suspense>
              }
            />
            <Route
              path={`${ROUTES.CUSTOMER_DYNAMIC_PACKAGE_OFFER}/:hotelid/dynamic/:dynamicOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
                  <DynamicPackagesMaintenanceRouteGate gateTriggered="public_customer_dynamic_package_offer_dynamic_order">
                    <CustomerDynamicOfferEntry />
                  </DynamicPackagesMaintenanceRouteGate>
                </Suspense>
              }
            />
            {/* Unsaved flow only: validates context / localStorage then renders PackagesProfile */}
            <Route
              path={`/${ROUTES.PACKAGE_PROFILE}`}
              element={
                <Suspense fallback={<CustomLoading label="טוען פרופיל חבילה..." overlay size="large" />}>
                  <UnsavedPackagesProfile />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.PACKAGE_PROFILE}/draft/:id`}
              element={
                <Suspense fallback={<CustomLoading label="טוען פרופיל חבילה..." overlay size="large" />}>
                  <SavedPackagesProfile profileType="draft" />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.PACKAGE_PROFILE}/:id/success`}
              element={
                <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
                  <PackageOrderSuccessPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.PACKAGE_PROFILE}/:id`}
              element={
                <Suspense fallback={<CustomLoading label="טוען פרופיל חבילה..." overlay size="large" />}>
                  <SavedPackagesProfile />
                </Suspense>
              }
            />
            <Route
              path={`${ROUTES.TOURE_PROFILE}`}
              element={<OrganizedTourLegacyProfileRedirect />}
            />
            <Route
              path={`${ROUTES.TOURE_PROFILE}/:id`}
              element={<SavedToursProfile />}
            />
            <Route
              path={`${ROUTES.ORDER_SUCCESS}/:id`}
              element={
                <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
                  <LegacyPackagesSuccessRedirect />
                </Suspense>
              }
            />
            {/* <Route
              path={`${ROUTES.HOTEL_PROFILE}/:currentOrderId`}
              element={<PaymentAgent isPublic />}
            /> */}
            <Route
              path={`${ROUTES.HOTEL_OFFER}/:hotelOrderId`}
              element={
                <div className="agent-pages tw-flex tw-flex-col tw-bg-white tw-min-h-full  tw-relative tw-w-full tw-overflow-hidden">
                  <Helmet>
                    <title>הצעה עבור מלון</title>
                    <meta
                      name="description"
                      content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
                    />
                    <meta property="og:title" content={`הצעת מחיר`} />
                    <meta property="og:type" content="website" />
                    <meta
                      property="og:description"
                      content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
                    />
                    <meta property="og:url" content={buildPublicPageCanonicalHref()} />
                  </Helmet>
                  <div className="agent-content guest">
                    <div className="agent-component">
                      {dynamicOrder ? (
                        <Helmet>
                          <title>
                            הצעה עבור מלון ל
                            {dynamicOrder?.hotel?.hotelname || ""}
                          </title>
                          <meta
                            name="description"
                            content={
                              "לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"
                            }
                          />
                          <meta
                            property="og:title"
                            content={`הצעת מחיר מספר ${dynamicOrder?.id || ""}`}
                          />
                          <meta property="og:type" content="website" />
                          <meta
                            property="og:description"
                            content={
                              "לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"
                            }
                          />
                          <meta
                            property="og:url"
                            content={buildPublicPageCanonicalHref()}
                          />
                        </Helmet>
                      ) : null}
                      <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
                        <DynamicPackagesMaintenanceRouteGate gateTriggered="public_hotel_offer_price_offer">
                          <PriceOfferComponent />
                        </DynamicPackagesMaintenanceRouteGate>
                      </Suspense>
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={`${ROUTES.DYNAMIC_OFFER}/:dynamicOrderId`}
              element={
                <div className="agent-pages tw-flex tw-flex-col tw-bg-white tw-min-h-full  tw-relative tw-w-full tw-overflow-hidden">
                  <Helmet>
                    <title>
                      {dynamicOrder && isFlightsNewProposalPackage(dynamicOrder)
                        ? "הצעת טיסה (PROPOSAL)"
                        : "הצעה עבור מלון וטיסות"}
                    </title>
                    <meta
                      name="description"
                      content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
                    />
                    <meta property="og:title" content={`הצעת מחיר`} />
                    <meta property="og:type" content="website" />
                    <meta
                      property="og:description"
                      content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
                    />
                    <meta property="og:url" content={buildPublicPageCanonicalHref()} />
                  </Helmet>
                  <div className="agent-content guest">
                    <div className="agent-component">
                      {dynamicOrder ? (
                        <Helmet>
                          <title>
                            {isFlightsNewProposalPackage(dynamicOrder)
                              ? `הצעת טיסה — מס׳ ${dynamicOrder?.id || ""}`
                              : `הצעה עבור מלון וטיסות ל${dynamicOrder?.hotel?.hotelname || ""}`}
                          </title>
                          <meta
                            name="description"
                            content={
                              "לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"
                            }
                          />
                          <meta
                            property="og:title"
                            content={
                              isFlightsNewProposalPackage(dynamicOrder)
                                ? `הצעת טיסה מס׳ ${dynamicOrder?.id || ""}`
                                : `הצעת מחיר מספר ${dynamicOrder?.id || ""}`
                            }
                          />
                          <meta property="og:type" content="website" />
                          <meta
                            property="og:description"
                            content={
                              "לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"
                            }
                          />
                          <meta
                            property="og:url"
                            content={buildPublicPageCanonicalHref()}
                          />
                        </Helmet>
                      ) : null}
                      <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
                        <DynamicPackagesMaintenanceRouteGate gateTriggered="public_dynamic_offer">
                          <PriceOfferComponent />
                        </DynamicPackagesMaintenanceRouteGate>
                      </Suspense>
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={`${ROUTES.FLIGHTS_OFFER}/:dynamicOrderId`}
              element={
                <div className="agent-pages tw-flex tw-flex-col tw-bg-white tw-min-h-full  tw-relative tw-w-full tw-overflow-hidden">
                  <Helmet>
                    <title>הצעת טיסה</title>
                    <meta
                      name="description"
                      content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
                    />
                    <meta property="og:title" content={`הצעת טיסה`} />
                    <meta property="og:type" content="website" />
                    <meta
                      property="og:description"
                      content={"לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"}
                    />
                    <meta property="og:url" content={buildPublicPageCanonicalHref()} />
                  </Helmet>
                  <div className="agent-content guest">
                    <div className="agent-component">
                      {dynamicOrder ? (
                        <Helmet>
                          <title>
                            {`הצעת טיסה — מס׳ ${dynamicOrder?.id || ""}`}
                          </title>
                          <meta
                            name="description"
                            content={
                              "לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"
                            }
                          />
                          <meta
                            property="og:title"
                            content={`הצעת טיסה מס׳ ${dynamicOrder?.id || ""}`}
                          />
                          <meta property="og:type" content="website" />
                          <meta
                            property="og:description"
                            content={
                              "לקוח יקר, מצורפת הצעת מחיר לעיונך ואישורך"
                            }
                          />
                          <meta
                            property="og:url"
                            content={buildPublicPageCanonicalHref()}
                          />
                        </Helmet>
                      ) : null}
                      <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
                        <DynamicPackagesMaintenanceRouteGate gateTriggered="public_flights_offer">
                          <PriceOfferComponent />
                        </DynamicPackagesMaintenanceRouteGate>
                      </Suspense>
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={`${ROUTES.DYNAMIC_PROFILE}/:dynamicOrderId`}
              element={
                <div className="agent-pages tw-flex tw-flex-col tw-bg-white tw-min-h-full  tw-relative tw-w-full tw-overflow-hidden">
                  <div className="agent-content">
                    <div className="agent-component">
                      <Suspense fallback={<CustomLoading label="טוען תשלום..." overlay size="large" />}>
                        <DynamicPackagesMaintenanceRouteGate gateTriggered="public_dynamic_profile_payment">
                          <PaymentAgent />
                        </DynamicPackagesMaintenanceRouteGate>
                      </Suspense>
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={`${ROUTES.DYNAMIC_SUCCESS}/:dynamicOrderId`}
              element={
                <div className="agent-pages tw-flex tw-flex-col tw-bg-white tw-min-h-full  tw-relative tw-w-full tw-overflow-hidden">
                  <div className="agent-content">
                    <div className="agent-component">
                      <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
                        <DynamicPackagesMaintenanceRouteGate gateTriggered="public_dynamic_success">
                          <SuccessOrder />
                        </DynamicPackagesMaintenanceRouteGate>
                      </Suspense>
                    </div>
                  </div>
                </div>
              }
            />
            <Route
              path={`/${ROUTES.FLIGHT_BOOKING}`}
              element={<FlightsBookingRootRedirect />}
            />
            <Route
              path={`/${ROUTES.FLIGHT_BOOKING}/:flightOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען טיסות..." overlay size="large" />}>
                  <FlightBookingPage />
                </Suspense>
              }
            />
            <Route path="/vacation_packages/*" element={<VacationPackagesLegacyPathRedirect />} />
            {/* /package/view מתאים ל-:id עם id="view" – אין route נפרד ל-view.
                PublicSiteProvider לפני Suspense כדי ש־fallback <Loader /> יקבל לוגו סוכנות. */}
            <Route
              path={`/${ROUTES.VACATION_PACKAGE_DETAIL}/:id`}
              element={
                <PublicSiteProvider>
                  <Suspense fallback={<Loader />}>
                    <VacationPackagesPage key="vacation-packages-detail" />
                  </Suspense>
                </PublicSiteProvider>
              }
            />
            <Route
              path={`/${ROUTES.VACATION_PACKAGES}`}
              element={
                <PublicSiteProvider>
                  <Suspense fallback={<Loader />}>
                    <VacationPackagesPage key="vacation-packages-root" />
                  </Suspense>
                </PublicSiteProvider>
              }
            />
            <Route
              path={`/${ROUTES.VACATION_PACKAGES_DESTINATION}/:destinationSlug`}
              element={
                <PublicSiteProvider>
                  <Suspense fallback={<Loader />}>
                    <VacationPackagesPage key="vacation-packages-destination" />
                  </Suspense>
                </PublicSiteProvider>
              }
            />
            <Route
              path={`/${ROUTES.AGENT_MINI_SITE}/:agentId/flights`}
              element={<Navigate to="search" replace />}
            />
            <Route
              path={`/${ROUTES.AGENT_MINI_SITE}/:agentId/flights/booking`}
              element={<AgentFlightsBookingRootRedirect />}
            />
            <Route
              path={`/${ROUTES.AGENT_MINI_SITE}/:agentId/flights/search`}
              element={
                <Suspense fallback={<CustomLoading label="טוען טיסות..." overlay size="large" />}>
                  <AgentMiniSiteFlightBookingEntry />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.AGENT_MINI_SITE}/:agentId/flights/results`}
              element={
                <Suspense fallback={<CustomLoading label="טוען טיסות..." overlay size="large" />}>
                  <AgentMiniSiteFlightBookingEntry />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.AGENT_MINI_SITE}/:agentId/flights/review`}
              element={
                <Suspense fallback={<CustomLoading label="טוען טיסות..." overlay size="large" />}>
                  <AgentMiniSiteFlightBookingEntry />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.AGENT_MINI_SITE}/:agentId/flights/booking/:flightOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען טיסות..." overlay size="large" />}>
                  <AgentMiniSiteFlightBookingEntry />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.AGENT_MINI_SITE}/:agentId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען אתר סוכן..." overlay size="large" />}>
                  <AgentMiniSite />
                </Suspense>
              }
            />
            <Route path="/customer-chat/start" element={<CustomerChatPublicStartPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route
              path={`/${ROUTES.CAMPAIGN_BELVEDERE}/offer/:orderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען הצעת מחיר..." overlay size="large" />}>
                  <BelvedereCampaignOfferPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_BELVEDERE}/payment/success/:orderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
                  <BelvedereCampaignPaymentSuccessPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_BELVEDERE}/payment/:currentOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען תשלום..." overlay size="large" />}>
                  <BelvedereCampaignPaymentPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_BELVEDERE}`}
              element={
                <Suspense fallback={<CustomLoading label="טוען דף קמפיין..." overlay size="large" />}>
                  <BelvedereHotelLandingPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_TULIP}/offer/:orderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען הצעת מחיר..." overlay size="large" />}>
                  <BelvedereCampaignOfferPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_TULIP}/payment/success/:orderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
                  <BelvedereCampaignPaymentSuccessPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_TULIP}/payment/:currentOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען תשלום..." overlay size="large" />}>
                  <BelvedereCampaignPaymentPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_TULIP}`}
              element={
                <Suspense fallback={<CustomLoading label="טוען דף קמפיין..." overlay size="large" />}>
                  <RoyalTulipTbilisiLandingPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}/offer/:orderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען הצעת מחיר..." overlay size="large" />}>
                  <BelvedereCampaignOfferPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}/payment/success/:orderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
                  <BelvedereCampaignPaymentSuccessPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}/payment/:currentOrderId`}
              element={
                <Suspense fallback={<CustomLoading label="טוען תשלום..." overlay size="large" />}>
                  <BelvedereCampaignPaymentPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.CAMPAIGN_ROYAL_ZANZIBAR}`}
              element={
                <Suspense fallback={<CustomLoading label="טוען דף קמפיין..." overlay size="large" />}>
                  <RoyalZanzibarBeachResortLandingPage />
                </Suspense>
              }
            />
            <Route path="/zoom/agents-transition" element={<ZoomOnePagerPage />} />
            <Route
              path={`/${ROUTES.ATTRACTIONS}`}
              element={
                <Suspense
                  fallback={
                    <CustomLoading label="טוען אטרקציות..." overlay size="large" />
                  }
                >
                  <AttractionsCatalogPage />
                </Suspense>
              }
            />
            <Route
              path={`/${ROUTES.ATTRACTIONS}/:identifier`}
              element={
                <Suspense
                  fallback={
                    <CustomLoading label="טוען אטרקציה..." overlay size="large" />
                  }
                >
                  <AttractionPublicPage />
                </Suspense>
              }
            />
            {/*<Route path={`Payment`} element={<Payment />} />*/}
            {/* Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          </ErrorBoundary>
        </div>
        {!isVacationPackagesPage &&
          !isCustomerChatPublic &&
          !isPublicOfferLinkPage &&
          !isManoQuotePublicPage &&
          !isManoPassportUploadPublicPage &&
          !isZoomOnePager &&
          !isCustomerPortal &&
          !isPublicBookingConfirmation &&
          !isDevServiceRequestsMock &&
          !isLoginMonthlyMockup &&
          !isReservationDetailsV2Preview &&
          !isBelvedereCustomerImmersivePath && (
          <FooterSection />
        )}
        {!isCustomerPortal &&
        !isPublicBookingConfirmation &&
        !isDevServiceRequestsMock &&
        !isLoginMonthlyMockup &&
        !isReservationDetailsV2Preview &&
        !isHubwayzHotelPreview ? (
          <GoogleReviewsPanel />
        ) : null}
      </div>
    );
  };

  const SecureClientRoutes = () => {
    return (
      <div className="client-pages">
        <UpperNavBarClient hotelName={hotelName} />

        <div className="client-component">
          <Routes>
            {/* נתיבים מלאים — אחרי login / איזור אישי מגיעים ל־/p/dashboard/... (לא רק "") */}
            <Route path="/p/dashboard" element={<Navigate to="/p/dashboard/home" replace />} />
            <Route path="/p/dashboard/" element={<Navigate to="/p/dashboard/home" replace />} />
            <Route path="/p/dashboard/home" element={<SecureClient />} />
            <Route path="/p/dashboard/profile" element={<SecureClient />} />
            <Route path="/p/dashboard/orders" element={<SecureClient />} />
            <Route path="/p/dashboard/saved" element={<SecureClient />} />
            <Route path="/p/dashboard/settings" element={<SecureClient />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </div>
    );
  };

  /**
   * מפריד בין ה-provider לבין ה-chrome עצמו כדי שנוכל לצרוך
   * useAgentBillingStatus באותה עץ (ה-hook דורש להיות מתחת לפרוביידר).
   * כאן נמצא ה-route guard האפקטיבי: כאשר isBlocked = true נחליף את
   * תוכן הדשבורד ב-BillingLockedView, וגם BillingMigrationGateModal יישאר
   * פתוח מעל (בלי אפשרות סגירה). זה מכסה גם ניווט ידני ב-URL כי
   * ה-chrome עוטף את כל /p/dashboard/*.
   */
  function AgentDashboardChromeInner({ sideBarOpen, setSidebarOpen, children }) {
    const location = useLocation();
    const packagesResultsChromeActive = useIsPackagesResultsChromeActive();
    const { locale } = useProductContext();
    const { adminFocusMode, setAdminFocusMode } = useAppContext();
    const isHebrewShell = locale === "he";
    const dashboardBase = isHebrewShell ? "/p/dashboard" : location.pathname.match(/^\/(en|el)\/dashboard/)?.[0] || "/en/dashboard";
    const isAdminDashboardPath = isHebrewShell && location.pathname.includes(`${dashboardBase}/admin`);
    const isManoAdminFullScreenRoute =
      location.pathname === "/p/dashboard/admin/mano-reconciliation" ||
      location.pathname === "/p/dashboard/admin/mano";
    const isJ5PendingCapturesFullScreenRoute = location.pathname.includes(
      "/p/dashboard/admin/j5-pending-captures",
    );
    const isBelvedereInventoryFullScreenRoute = location.pathname.includes(
      "/p/dashboard/admin/belvedere-inventory",
    );
    const isOperationRequestsFullScreenRoute = location.pathname.includes(
      "/p/dashboard/admin/operation-requests",
    );
    const isPackagesPaymentMockupRoute = location.pathname.includes(
      "/packages-payment-mockup",
    );
    const isPackagesResultsMockupRoute = location.pathname.includes(
      "/packages-results-mockup",
    );
    const isHotelsResultsMockupRoute = location.pathname.includes(
      "/hotels-results-mockup",
    );
    const isHotelProfileMockupRoute = location.pathname.includes(
      "/hotel-profile-mockup",
    );
    const isUnifiedSearchMockupRoute = location.pathname.includes(
      "/unified-search-mockup",
    );
    const isHotelsSearchMockupRoute = location.pathname.includes(
      "/hotels-search-mockup",
    );
    const isBookingConfirmationMockupRoute = location.pathname.includes(
      "/booking-confirmation-mockup",
    );
    const isHubwayzHotelBookingRoute =
      location.pathname.includes("/dashboard/hotel/") ||
      location.pathname.includes("/hubwayz-hotel/");
    const isHubwayzHotelPreviewRoute =
      location.pathname.includes("/hotel-preview") ||
      location.pathname.includes("/hotel-offer-preview") ||
      location.pathname.includes("/hubwayz-hotel-preview") ||
      location.pathname.includes("/hubwayz-hotel-offer-preview");
    const { isBlocked } = useAgentBillingStatus();
    const isolateChrome =
      import.meta.env.DEV &&
      typeof window !== "undefined" &&
      (window.__PERF_ISOLATE_CHROME__ ?? true);
    if (
      import.meta.env.DEV &&
      typeof window !== "undefined" &&
      window.__RENDER_TRACE__ === true
    ) {
      console.count("[RENDER_TRACE] AgentDashboardChromeInner");
    }

    useEffect(() => {
      if (!isAdminDashboardPath) {
        setAdminFocusMode(false);
      }
    }, [isAdminDashboardPath, setAdminFocusMode]);

    const adminFocusLayoutActive = isAdminDashboardPath && adminFocusMode;

    if (!isHebrewShell) {
      return (
        <InternationalDashboardLayout>
          {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
        </InternationalDashboardLayout>
      );
    }

    if (isPackagesPaymentMockupRoute) {
      return (
        <div className="agent-pages tw-flex tw-flex-col tw-relative tw-w-full tw-h-full agent-pages--packages-ppm">
          <div className="agent-component agent-component--packages-ppm">
            {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
          </div>
        </div>
      );
    }

    if (isPackagesResultsMockupRoute) {
      return (
        <div className="agent-pages tw-flex tw-flex-col tw-relative tw-w-full tw-h-full agent-pages--packages-hrm">
          <div className="agent-component agent-component--packages-hrm">
            {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
          </div>
        </div>
      );
    }

    if (isHotelsResultsMockupRoute || isHotelProfileMockupRoute) {
      return (
        <div className="agent-pages tw-flex tw-flex-col tw-relative tw-w-full tw-h-full agent-pages--packages-hrm">
          <div className="agent-component agent-component--packages-hrm">
            {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
          </div>
        </div>
      );
    }

    if (
      isUnifiedSearchMockupRoute ||
      isHotelsSearchMockupRoute ||
      isBookingConfirmationMockupRoute ||
      isHubwayzHotelBookingRoute ||
      isHubwayzHotelPreviewRoute
    ) {
      return (
        <div className="agent-pages tw-flex tw-flex-col tw-relative tw-w-full tw-h-full agent-pages--packages-ppm">
          <div className="agent-component agent-component--packages-ppm">
            {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
          </div>
        </div>
      );
    }

    if (
      isManoAdminFullScreenRoute ||
      isJ5PendingCapturesFullScreenRoute ||
      isBelvedereInventoryFullScreenRoute ||
      isOperationRequestsFullScreenRoute
    ) {
      return (
        <RemindersHubProvider>
          <div className="agent-pages tw-flex tw-flex-col tw-bg-white tw-relative tw-w-full tw-h-full admin-focus-mode">
            <div className="agent-content agent-content--admin">
              <div className="agent-component agent-component--admin">
                {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
              </div>
            </div>
          </div>
        </RemindersHubProvider>
      );
    }

    if (packagesResultsChromeActive) {
      return (
        <RemindersHubProvider>
          <div className="agent-pages agent-pages--packages-hrm tw-flex tw-flex-col tw-bg-white tw-relative tw-w-full tw-h-full">
            <AgentPackagesResultsChrome>
              <div className="agent-component agent-component--packages-hrm">
                {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
              </div>
            </AgentPackagesResultsChrome>
          </div>
          <RemindersChrome />
          <BillingMigrationGateModal />
        </RemindersHubProvider>
      );
    }

    if (isolateChrome) {
      return (
        <RemindersHubProvider>
          <div
            className={`agent-pages hr-agent-shell tw-flex tw-flex-col tw-bg-white tw-relative tw-w-full tw-h-full${adminFocusLayoutActive ? " admin-focus-mode" : ""}`}
          dir="rtl"
          lang="he"
          >
            <UpperNavBarAgent sideBarOpen={sideBarOpen} />
            <div className={`agent-content${isAdminDashboardPath ? " agent-content--admin" : ""}`}>
              <Sidenav setSidebarOpen={setSidebarOpen} />
              <div
                className={`agent-component${isAdminDashboardPath ? " agent-component--admin" : ""}`}
              >
                {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
              </div>
            </div>
          </div>
        </RemindersHubProvider>
      );
    }

    return (
      <RemindersHubProvider>
        <div
          className={`agent-pages hr-agent-shell tw-flex tw-flex-col tw-bg-white tw-relative tw-w-full tw-h-full${adminFocusLayoutActive ? " admin-focus-mode" : ""}`}
          dir="rtl"
          lang="he"
        >
          <UpperNavBarAgent sideBarOpen={sideBarOpen} />
          <div
            className={`agent-content${isAdminDashboardPath ? " agent-content--admin" : ""}`}
          >
            <Sidenav setSidebarOpen={setSidebarOpen} />
            <div
              className={`agent-component${isAdminDashboardPath ? " agent-component--admin" : ""}`}
            >
              {isBlocked ? <BillingLockedView /> : <MemoChildren>{children}</MemoChildren>}
            </div>
          </div>
          <FooterSection />
          <GoogleReviewsPanel />
        </div>
        <RemindersChrome />
        <BillingMigrationGateModal />
      </RemindersHubProvider>
    );
  }

  function AgentDashboardChrome(props) {
    return (
      <AgentBillingStatusProvider>
        <AgentAccountOverviewProvider>
          <OperationRequestProvider>
            <AgentDashboardChromeInner {...props} />
          </OperationRequestProvider>
        </AgentAccountOverviewProvider>
      </AgentBillingStatusProvider>
    );
  }

  /** Hebrew agent dashboard — full route tree under legacy /p/dashboard basename. */
  function HebrewAgentDashboardBodyRoutes() {
    return (
      <Routes basename="/p/dashboard">
        <Route index element={<Navigate to="home" replace />} />
        <Route path="home" element={<DashboardPage />} />
          <Route path="hr-commissions" element={<HrCommissionOrdersPage />} />
        <Route path="payment-method-return" element={<PaymentMethodVaultReturn />} />
        <Route path="drafts" element={<SalesLinks pageType="drafts" />} />
        <Route path="sales-links" element={<SalesLinks />} />
        <Route
          path="mano-quotes"
          element={
            <EntitlementGate
              featureKey="mano_quotes"
              title="הצעות מנו ספנות אינן כלולות בחבילה הנוכחית"
              description="אדמין יכול להפעיל את הפיצ׳ר דרך ניהול חבילות (פיצ׳רי חבילות)."
            >
              <RouteChunkSuspense label="טוען הצעות מנו...">
                <ManoQuotesListPage />
              </RouteChunkSuspense>
            </EntitlementGate>
          }
        />
        <Route
          path="mano-quotes/passport-uploads"
          element={
            <EntitlementGate
              featureKey="mano_quotes"
              title="הצעות מנו ספנות אינן כלולות בחבילה הנוכחית"
              description="אדמין יכול להפעיל את הפיצ׳ר דרך ניהול חבילות (פיצ׳רי חבילות)."
            >
              <RouteChunkSuspense label="טוען העלאת דרכונים...">
                <ManoPassportUploadsPage />
              </RouteChunkSuspense>
            </EntitlementGate>
          }
        />
        <Route
          path="mano-quotes/new"
          element={
            <EntitlementGate
              featureKey="mano_quotes"
              title="הצעות מנו ספנות אינן כלולות בחבילה הנוכחית"
              description="אדמין יכול להפעיל את הפיצ׳ר דרך ניהול חבילות (פיצ׳רי חבילות)."
            >
              <RouteChunkSuspense label="טוען אשף הצעה...">
                <ManoQuoteWizardPage />
              </RouteChunkSuspense>
            </EntitlementGate>
          }
        />
        <Route
          path="mano-quotes/:quoteId/edit"
          element={
            <EntitlementGate
              featureKey="mano_quotes"
              title="הצעות מנו ספנות אינן כלולות בחבילה הנוכחית"
              description="אדמין יכול להפעיל את הפיצ׳ר דרך ניהול חבילות (פיצ׳רי חבילות)."
            >
              <RouteChunkSuspense label="טוען אשף הצעה...">
                <ManoQuoteWizardPage />
              </RouteChunkSuspense>
            </EntitlementGate>
          }
        />
        <Route
          path="mano-quotes/:quoteId"
          element={
            <EntitlementGate
              featureKey="mano_quotes"
              title="הצעות מנו ספנות אינן כלולות בחבילה הנוכחית"
              description="אדמין יכול להפעיל את הפיצ׳ר דרך ניהול חבילות (פיצ׳רי חבילות)."
            >
              <RouteChunkSuspense label="טוען הצעה...">
                <ManoQuoteViewPage />
              </RouteChunkSuspense>
            </EntitlementGate>
          }
        />
        <Route path="cruise-payment" element={<CruisePayment />} />
        <Route
          path="orders"
          element={
            <RouteChunkSuspense label="טוען הזמנות...">
              <OrdersV2Page />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="orders/packages/:orderId"
          element={
            <RouteChunkSuspense label="טוען פרטי הזמנה...">
              <PackageOrderDetailsPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="orders/flights/:orderId"
          element={
            <RouteChunkSuspense label="טוען פרטי הזמנה...">
              <PackageOrderDetailsPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="orders/hotels/:orderId"
          element={
            <RouteChunkSuspense label="טוען פרטי הזמנה...">
              <HotelOrderDetailsPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="orders/dynamic-packages/:orderId"
          element={
            <RouteChunkSuspense label="טוען פרטי הזמנה...">
              <DynamicPackagesMaintenanceRouteGate gateTriggered="orders_dynamic_package_detail">
                <DynamicPackageOrderDetailsPage />
              </DynamicPackagesMaintenanceRouteGate>
            </RouteChunkSuspense>
          }
        />
        <Route
          path="orders/organized-tours/:orderId"
          element={
            <RouteChunkSuspense label="טוען פרטי הזמנה...">
              <PackageOrderDetailsPage />
            </RouteChunkSuspense>
          }
        />
        <Route path="orders/:category" element={<OrdersRouteWrapper />} />
        <Route
          path="finance"
          element={
            <Suspense fallback={<CustomLoading label="טוען פיננסים..." overlay size="large" />}>
              <Finance />
            </Suspense>
          }
        />
        <Route path="admin" element={<LazyAdminRoute />} />
        <Route path="admin/agents" element={<LazyAdminRoute />} />
        <Route path="admin/agent-mail" element={<LazyAdminRoute />} />
        <Route path="admin/packages" element={<LazyAdminRoute />} />
        <Route path="admin/academy" element={<LazyAdminRoute />} />
        <Route path="admin/internal-hotels" element={<LazyAdminRoute />} />
        <Route path="admin/pinned-hotels" element={<LazyAdminRoute />} />
        <Route path="admin/belvedere-inventory" element={<LazyAdminRoute />} />
        <Route path="admin/belvedere-inventory/*" element={<LazyAdminRoute />} />
        <Route path="admin/internal-attractions" element={<LazyAdminRoute />} />
        <Route path="admin/package-features" element={<LazyAdminRoute />} />
        <Route path="admin/agent-billing" element={<LazyAdminRoute />} />
        <Route path="admin/morning-pending-payments" element={<LazyAdminRoute />} />
        <Route path="admin/j5-pending-captures" element={<LazyAdminRoute />} />
        <Route path="admin/team-management" element={<LazyAdminRoute />} />
        <Route path="admin/system-users" element={<LazyAdminRoute />} />
        <Route path="admin/agency-management" element={<LazyAdminRoute />} />
        <Route path="admin/agency-pricing" element={<LazyAdminRoute />} />
        <Route path="admin/pricing-audit" element={<LazyAdminRoute />} />
        <Route path="admin/pricing-engine-audit" element={<LazyAdminRoute />} />
        <Route path="admin/cron-monitoring" element={<LazyAdminRoute />} />
        <Route path="admin/seo-guard" element={<LazyAdminRoute />} />
        <Route path="admin/mano-reconciliation" element={<LazyAdminRoute />} />
        <Route path="admin/mano" element={<LazyAdminRoute />} />
        <Route path="admin/operation-requests" element={<LazyAdminRoute />} />
        <Route path="admin/corporate-companies" element={<LazyAdminRoute />} />
        <Route path="admin/agent-site-domains" element={<LazyAdminRoute />} />
        <Route path="management/upgrade" element={<AgentPackageUpgradePage />} />
        <Route path="management" element={<Management />} />
        <Route
          path="searchoffer/book/:selectedPackageId/dynamic/:dynamicOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchoffer/book/:selectedPackageId/hotel/:hotelOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchoffer/book/:selectedPackageId"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchoffer/:selectedPackageId/dynamic/:dynamicOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchoffer/:selectedPackageId/hotel/:hotelOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        {/*
          חייב לבוא לפני searchoffer/:selectedPackageId/flights/:flightStep —
          אחרת ‎/searchoffer/flights/results‎ נפרש כ־selectedPackageId="flights" ונשבר sync ל-URL.
        */}
        <Route
          path="searchoffer/flights/:flightStep"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchoffer/:selectedPackageId/flights/:flightStep"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchoffer/:selectedPackageId"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchoffer"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchhotels"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="searchdynamic"
          element={<DynamicProductInactivePage />}
        />
        <Route
          path="hotelprofile/:hotelId"
          element={
            <Suspense fallback={<CustomLoading label="טוען חבילות / חדרים..." overlay size="large" />}>
              <HotelProfile handleHotelName={() => {}} />
            </Suspense>
          }
        />
        <Route
          path="searchflights"
          element={<Navigate to="/p/dashboard/flights/search" replace />}
        />
        <Route
          path="packages/search"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="packages/results"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route path="organized-tours" element={<OrganizedToursKeyedOutlet />}>
          <Route
            path="search"
            element={
              <Suspense fallback={<CustomLoading label="טוען חיפוש טיול..." overlay size="large" />}>
                <OrganizedToursSearchPage />
              </Suspense>
            }
          />
          <Route
            path="results"
            element={
              <Suspense fallback={<CustomLoading label="טוען תוצאות טיול..." overlay size="large" />}>
                <OrganizedToursResultsPage />
              </Suspense>
            }
          />
          <Route
            path="profile/:dealId"
            element={
              <Suspense fallback={<CustomLoading label="טוען פרופיל טיול..." overlay size="large" />}>
                <OrganizedTourProfileRoute />
              </Suspense>
            }
          />
          <Route
            path="booking/:orderId"
            element={
              <Suspense fallback={<CustomLoading label="טוען פרטי נוסעים..." overlay size="large" />}>
                <OrganizedTourBookingPage />
              </Suspense>
            }
          />
          <Route
            path="payment/:orderId"
            element={
              <Suspense fallback={<CustomLoading label="טוען תשלום טיול..." overlay size="large" />}>
                <OrganizedTourPaymentPage />
              </Suspense>
            }
          />
        </Route>
        <Route path="tour/results" element={<TourResultsLegacyDashboardRedirect />} />
        <Route
          path="tour/profile/:dealId"
          element={<OrganizedTourLegacyDealProfileRedirect />}
        />
        <Route
          path="tour/profile"
          element={<OrganizedTourLegacyProfileRedirect />}
        />
        <Route
          path="flights/search"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route
          path="flights/results"
          element={
            <Suspense fallback={<CustomLoading label="טוען הצעה..." overlay size="large" />}>
              <PriceOffer />
            </Suspense>
          }
        />
        <Route path="flight-booking-mockup" element={<FlightBookingMockupStandalonePage />} />
        <Route
          path="flight-engine-v2-preview"
          element={<FlightEngineV2PreviewStandalonePage />}
        />
        <Route
          path="hotels-results-mockup"
          element={<HotelsResultsMockupStandalonePage />}
        />
        <Route
          path="hotel-profile-mockup"
          element={<HotelProfileMockupStandalonePage />}
        />
        <Route
          path="unified-search-mockup"
          element={<UnifiedSearchMockupStandalonePage />}
        />
        <Route
          path="hotels-search-mockup"
          element={<HotelsSearchMockupStandalonePage />}
        />
        {import.meta.env.DEV ? (
          <Route
            path="hotel-preview"
            element={<HubwayzHotelPreviewStandalonePage />}
          />
        ) : null}
        {import.meta.env.DEV ? (
          <Route
            path="hotel-offer-preview"
            element={<HubwayzHotelOfferPreviewPage />}
          />
        ) : null}
        {import.meta.env.DEV ? (
          <Route
            path="hubwayz-hotel-preview"
            element={<Navigate to="/p/dashboard/hotel-preview" replace />}
          />
        ) : null}
        {import.meta.env.DEV ? (
          <Route
            path="hubwayz-hotel-offer-preview"
            element={<Navigate to="/p/dashboard/hotel-offer-preview" replace />}
          />
        ) : null}
        <Route
          path="hotel/:hotelId"
          element={<HubwayzHotelBookingPage />}
        />
        <Route
          path="hubwayz-hotel/:hotelId"
          element={<LegacySupplierHotelRedirect />}
        />
        <Route path="searchpackages" element={<SearchPackagesToSearchOfferRedirect />} />
        <Route path="customers" element={<Customers />} />
        <Route path="ai-sales-leads" element={<AISalesLeadsRoute />} />
        <Route path="customer-chat-inbox" element={<CustomerChatInboxPage />} />
        <Route path="reports" element={<Reports />} />
        <Route path="academy" element={<Academy />} />
        <Route path="reminders" element={<RemindersPage />} />
        <Route path="remindes" element={<RemindersPage />} />
        <Route path="my-operation-requests" element={<AgentMyOperationRequestsPage />} />
        <Route path="my-operation-requests/:requestId" element={<AgentOperationRequestDetailPage />} />
        <Route path="operation-requests/new" element={<NewOperationRequestPage />} />
        <Route path="seo" element={<AgentSeoSettingsPage />} />
        <Route path="seo/articles" element={<AgentSeoArticlesPage />} />
        <Route
          path="site-settings"
          element={
            <AgentPublicSiteGate>
              <SiteSettingsPage />
            </AgentPublicSiteGate>
          }
        />
        <Route
          path="payment/:currentOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען תשלום..." overlay size="large" />}>
              <PaymentAgent />
            </Suspense>
          }
        />
        <Route
          path="success/:currentOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
              <SuccessOrder />
            </Suspense>
          }
        />
        <Route
          path="dynamic/profile/:dynamicOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען תשלום..." overlay size="large" />}>
              <DynamicPackagesMaintenanceRouteGate gateTriggered="dashboard_dynamic_profile_payment">
                <PaymentAgent />
              </DynamicPackagesMaintenanceRouteGate>
            </Suspense>
          }
        />
        <Route
          path={`${ROUTES.PACKAGES_FLIGHT_PROPOSAL}/:dynamicPackageId`}
          element={
            <DynamicPackagesMaintenanceRouteGate gateTriggered="dashboard_packages_flight_proposal">
              <FlightProposalAgentPage />
            </DynamicPackagesMaintenanceRouteGate>
          }
        />
        <Route
          path="dynamic/success/:dynamicOrderId"
          element={
            <Suspense fallback={<CustomLoading label="טוען אישור הזמנה..." overlay size="large" />}>
              <DynamicPackagesMaintenanceRouteGate gateTriggered="dashboard_dynamic_success">
                <SuccessOrder />
              </DynamicPackagesMaintenanceRouteGate>
            </Suspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  function AgentDashboardBodyRoutes() {
    const { locale } = useProductContext();
    if (locale !== "he") {
      return <InternationalAgentDashboardBodyRoutes />;
    }
    return <HebrewAgentDashboardBodyRoutes />;
  }

  const AgentRoutes = () => {
    const navigate = useNavigate();

    const [sideBarOpen, setSidebarOpen] = useState(getSideBarStatus());

    // CSS fixes on payment page
    useEffect(() => {
      const isPaymentPage = window.location.pathname.includes(
        "/p/dashboard/payment/"
      );

      if (!isPaymentPage) {
        // Remove classes starting with 'cie' from the agent component
        const removeCieClasses = () => {
          const allElements = document.querySelectorAll("*");

          allElements.forEach((element) => {
            const classes = element.classList;

            // Iterate through the classes and remove those starting with 'cie'
            classes.forEach((className) => {
              if (className.startsWith("cie")) {
                // Remove the class
                element.classList.remove(className);
              }
            });
          });
        };

        // Call the function on initial render
        removeCieClasses();
      }
    }, [navigate]);

    return (
      <FlightOfferUiProvider>
        <AgentDashboardLocalePolicy />
        <AgentDashboardChrome
          sideBarOpen={sideBarOpen}
          setSidebarOpen={setSidebarOpen}
        >
          <AgentDashboardBodyRoutes />
        </AgentDashboardChrome>
      </FlightOfferUiProvider>
    );
  };

  const AdminRoutes = () => (
    <div className="admin-pages">
      <Routes>
        <Route
          path="countries"
          element={
            <RouteChunkSuspense label="טוען...">
              <Countries />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="tournaments"
          element={
            <RouteChunkSuspense label="טוען...">
              <Tournaments />
            </RouteChunkSuspense>
          }
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );

  const SecureRoutes = () => {
    const navigate = useNavigate();
    const { isAppLoggedInValue } = useAppContext();

    const readSessionUser = () => getUserDetails();
    const hasPersistedSession = (u) =>
      !!(u && typeof u === "object" && (u.sessionID || u.sessionId));

    const [authenticated, setAuthenticated] = useState(() =>
      hasPersistedSession(readSessionUser())
    );
    const [authenticatedUser, setAuthenticatedUser] = useState(() => {
      const u = readSessionUser();
      return hasPersistedSession(u) ? u : null;
    });

    /** Skip redundant runs when only unrelated AppContext fields changed. */
    const lastSecureGateKeyRef = useRef("");

    useEffect(() => {
      const u = readSessionUser();
      const ctxLoggedIn = Boolean(isAppLoggedInValue);
      const sid =
        u && typeof u === "object"
          ? String(u.sessionID || u.sessionId || "").trim()
          : "";
      const ut =
        u && typeof u === "object"
          ? String(u.usertype || u.userType || "").trim()
          : "";
      const gateKey = `${ctxLoggedIn}|${hasPersistedSession(u)}|${sid}|${ut}`;
      if (lastSecureGateKeyRef.current === gateKey) {
        return;
      }
      lastSecureGateKeyRef.current = gateKey;

      if (hasPersistedSession(u) || ctxLoggedIn) {
        setAuthenticated(true);
        if (u && typeof u === "object") setAuthenticatedUser(u);
      } else {
        navigate(`/${ROUTES.MAIN}`);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps -- navigate stable in RR6; gateKey ref suppresses duplicate work
    }, [isAppLoggedInValue]);

    useEffect(() => {
      if (!authenticated) return;
      const u = readSessionUser();
      if (hasPersistedSession(u)) setAuthenticatedUser(u);
    }, [authenticated]);

    if (authenticated) {
      // Safety check: ensure authenticatedUser is an object before accessing properties
      if (
        !authenticatedUser ||
        typeof authenticatedUser !== "object" ||
        !authenticatedUser.usertype
      ) {
        return (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoaderModal />
          </div>
        );
      }
      
      if (authenticatedUser.usertype === "clients") {
        return (
          <div className="public-secure-routes">
            <Routes>
              {/* Client Secure Routes */}
              <Route path="/*" element={<SecureClientRoutes />} />
            </Routes>
          </div>
        );
      } else if (authenticatedUser.usertype === "corporate") {
        return (
          <div className="public-secure-routes">
            <Routes>
              {corporatePortalRoute}
              <Route path="/*" element={<Navigate to={CORPORATE_ROUTES.DASHBOARD} replace />} />
            </Routes>
          </div>
        );
      } else if (authenticatedUser.usertype === "agents") {
        return (
          <div className="public-secure-routes">
            <Routes>
              {/*
                RR7: התאמה מלאה ל־URL בדפדפן. חלק מהסביבות דורשות `/p/dashboard/*`.
                שני הנתיבים מפנים לאותו chrome של סוכן.
              */}
              <Route path="/p/dashboard/*" element={<AgentRoutes />} />
              {/*
                אחרי root `path="/p/*"` חלק מהגרסאות מנרמלות נתיב יחסי — משאירים גם `/dashboard/*`.
              */}
              <Route path="/dashboard/*" element={<AgentRoutes />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </div>
        );
      } else if (authenticatedUser.usertype === "admins") {
        return (
          <div className="public-secure-routes">
            <Routes>
              <Route path="/p/dashboard/*" element={<AgentRoutes />} />
              <Route path="/dashboard/*" element={<AgentRoutes />} />
              <Route path="/administration/*" element={<AdminRoutes />} />
              <Route path="/*" element={<NotFound />} />
            </Routes>
          </div>
        );
      } else {
        // pass
      }
    }

    // Render loading or placeholder content while the authentication check is in progress
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <LoaderModal />
      </div>
    );
  };

  if (isTripMasterSurface()) {
    return <TripMasterAppRoutes />;
  }

  return (
    <Router>
      <ProductContextProvider>
        <RouteLocaleSync />
        <AgentUpgradeFlowListener />
        <SeoMetaGuardRuntimeBridge />
        <RuntimeRouteTelemetry />
        <MetaPixelRouteTracker />
        <HotelsRiverChatGate />
        <Routes>
        <Route path="/" element={<WelcomeRootEntry />} />
        <Route path="/dashboard" element={<DashboardPublicRedirect />} />
        <Route path="/dashboard/*" element={<DashboardPublicRedirect />} />
        {/* לפני path="/*" — אחרת נתיב הדיבוג לא נבחר (הורה /* בולע את כל הנתיב) */}
        <Route
          path="/debug/flight-proposal/:dynamicPackageId"
          element={
            <div className="client-pages client-pages--package-offer-quote">
              <div
                className="client-component"
                style={{
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                  width: "100%",
                  minHeight: "100vh",
                  height: "auto",
                  flex: "1 1 auto",
                }}
              >
                <FlightProposalAgentPage />
              </div>
            </div>
          }
        />
        {/* Sprint 2 — locale-prefixed international agent dashboards */}
        <Route path="/he/dashboard" element={<HebrewDashboardCanonicalRedirect />} />
        <Route path="/he/dashboard/*" element={<HebrewDashboardCanonicalRedirect />} />
        <Route
          path="/en/dashboard/*"
          element={
            <SecureAgentDashboardGate>
              <AgentRoutes />
            </SecureAgentDashboardGate>
          }
        />
        <Route
          path="/el/dashboard/*"
          element={
            <SecureAgentDashboardGate>
              <AgentRoutes />
            </SecureAgentDashboardGate>
          }
        />
        {/* Corporate portal — before /p/* so company routes never hit agent SecureRoutes */}
        <Route
          path="/company/login"
          element={
            <RouteChunkSuspense label="טוען...">
              <CompanyLoginPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="/company/login/verify"
          element={
            <RouteChunkSuspense label="טוען אימות...">
              <CompanyLoginVerifyPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="/company/register"
          element={
            <RouteChunkSuspense label="טוען...">
              <CompanyRegisterPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="/company/forgot-password"
          element={
            <RouteChunkSuspense label="טוען...">
              <CompanyForgotPasswordPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="/company/reset-password/:token"
          element={
            <RouteChunkSuspense label="טוען...">
              <CompanyResetPasswordPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="/company/pending-approval"
          element={
            <RouteChunkSuspense label="טוען...">
              <CompanyPendingApprovalPage />
            </RouteChunkSuspense>
          }
        />
        <Route
          path="/business/invitation/:token"
          element={
            <RouteChunkSuspense label="טוען הזמנה...">
              <CorporateEmployeeInvitationPage />
            </RouteChunkSuspense>
          }
        />
        {corporatePortalRoute}
        {/* חייב לפני path="/p/*" — אחרת SecureRoutes בולע /p/company/dashboard (מסך לבן) */}
        <Route path="/p/*" element={<SecureRoutes />} />
        {/* Morning subscription return — must precede path="/*" (same pattern as /he/dashboard) */}
        <Route
          path="/he/subscription-payment-success"
          element={
            <LocaleAwarePublicRoutes>
              <SubscriptionPaymentSuccessEntry />
            </LocaleAwarePublicRoutes>
          }
        />
        {/* Public Routes — /he/ and /us/ locale prefixes (single /* parent; no nested splat) */}
        <Route
          path="/*"
          element={
            <LocaleAwarePublicRoutes>
              <PublicClientRoutes />
            </LocaleAwarePublicRoutes>
          }
        />
        </Routes>
        <DevViewModeSwitch />
      </ProductContextProvider>
    </Router>
  );
};

export default React.memo(InnerRoutes);
